import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-terms',
  templateUrl: './dialog-terms.component.html'
})
export class DialogTermsComponent implements OnInit {

  @Input() allTerms: any;
  disabled =  true;
  @Output() eventEmitButton = new EventEmitter<any>(true);
   
  
  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<DialogTermsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.allTerms = data.allTerms;
     }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }

  actionCheckBox(event, terms){
      this.allTerms.find(term => {
        if(term.id == terms.id)
          term.checked = event.checked;

        if(this.allTerms.every(e => e.checked))
          this.disabled = false;

        if(!this.allTerms.every(e => e.checked))
        this.disabled = true;
      });
  }

  onEmit(){
    this.eventEmitButton.emit();
    this.close();
  }

}
